//import _ from 'underscore'

import basicController from 'servicestack/basic.controller.properties';
import $session from 'servicestack/session';
import $appConfig from 'servicestack/config';
import templateUrl from 'emun.salesrep/repgroup-dashboard.htm';
import AutoQuery from 'servicestack/auto-query/auto-query.es6';
import salesrepConfig from 'emun.salesrep/salesrep.config';

class RepGroupDashboardController {
	constructor(createAutoQuery, $session, $window, $state) {
		basicController(this);
		var map = this;
		let $ctrl = this;
		$ctrl.salesrepConfig = salesrepConfig;
		$ctrl.chartLoaded = false;
		this.productImage = $appConfig.productImage.bind($appConfig);
		this.todaySales = {
			total: 0,
			count: 0
		};
		$ctrl.dailySales = {
			total: 0,
			count: 0
		};
		this.yesterdaySales = {
			total: 0,
			count: 0
		};
		this.weekSales = {
			total: 0,
			count: 0
		};
		this.lastweekSales = {
			total: 0,
			count: 0
		};
		this.monthSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		this.lastmonthSales = {
			total: 0,
			count: 0
		};
		this.quarterSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		this.lastquarterSales = {
			total: 0,
			count: 0
		};
		this.ytdSales = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		this.lastytdSales = {
			total: 0,
			count: 0
		};
		this.goals = {
			month: 0,
			monthPercent: 0,
			quarter: 0,
			quarterPercent: 0,
			year: 0,
			yearPercent: 0
		};
		$ctrl.dailyInvoice = {
			total: 0,
			count: 0
		};
		$ctrl.yesterdayInvoice = {
			total: 0,
			count: 0
		};
		$ctrl.weekInvoice = {
			total: 0,
			count: 0
		};
		$ctrl.lastweekInvoice = {
			total: 0,
			count: 0
		};
		$ctrl.quarterInvoice = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		$ctrl.lastquarterInvoice = {
			total: 0,
			count: 0
		};
		$ctrl.ytdInvoice = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		$ctrl.lastytdInvoice = {
			total: 0,
			count: 0
		};
		$ctrl.mtdInvoice = {
			total: 0,
			count: 0,
			percent: 0,
			trend: 'neutral'
		};
		$ctrl.lastmtdInvoice = {
			total: 0,
			count: 0
		};
		this.uniqueCustomersBooked = 0;
		this.newAccountsBooked = 0;
		this.newAccountsBookedYTD = 0;
		this.storeVisits = 0;
		this.avgAppointment = 0;

		$ctrl.repGroupFilter = '';
		$ctrl.goalsFilter = '';
		if ($ctrl.repGroup !== 'ALL') {
			$ctrl.repGroupFilter = '&RepGroupName=' + $ctrl.repGroup;
		}
		if ($ctrl.insideSales === 'true') {
			$ctrl.repGroupFilter = '&IsInsideSales=true';
		} else {
			//put this back in because of Christina's feedback - RH 8/5/2020
			//for the All Divisions tab, include inside sales
			//as well as normal inside sales
			if ($ctrl.repGroup !== 'ALL') { //don't filter for all divisions

				$ctrl.repGroupFilter = $ctrl.repGroupFilter + '&IsInsideSales=false';
			} else {
				$ctrl.goalsFilter = '&IsInsideSales=false';
			}
		}

		$ctrl.todaySalesQuery = new AutoQuery({
			url:
				"QueryCartsJoin.json?StatusIn=Open,Completed&Sum=GrandTotal&GroupBy=OrderedOn",
			autoLoad: true,
			criteria: {
				OrderedOn: moment().format("l"),
				clientDateTime: moment().format("MM/DD/YYYY H:m:s Z")
				//dateRange: 'Today'
			},
			scrollTop: false,
			disableQueryString: true,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.todaySales.total += res.sumGrandTotal;
					});
				}
			}
		});

		$ctrl.dailySales = createAutoQuery({
		 url: 'QuerySalesDailyTotals.json?dateRange=Today&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
		 autoLoad: true,
		 pageSize: 1000,
		 onLoaded: function (args) {
		   if (args.total > 0) {
		     args.results.forEach(function (res) {
		       $ctrl.dailySales.total += Math.round(res.sumOrderTotal);
		       $ctrl.dailySales.count += res.countOrderTotal;
		     });
		     //$ctrl.bookingsToday = $ctrl.todaySales.total;
		   }
		 }
		});

		$ctrl.yesterdaySalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=Yesterday&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.yesterdaySales.total += Math.round(res.sumOrderTotal);
						$ctrl.yesterdaySales.count += res.countOrderTotal;
					});
					$ctrl.bookingsYesterday = $ctrl.yesterdaySales.total;
				}
			}
		});

		$ctrl.bookingsThisWeek = 0;

		//I had to do this so that I could start the week on Sunday
		//it appears hardcoded to Monday in the autoquery for QuerySalesDailyTotals
		var dateWeekStart = '';
		if ($ctrl.insideSales === 'true') {
			dateWeekStart = '&WeekStart=Sunday';
		}

		$ctrl.weekSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=Week' + dateWeekStart + '&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName,Source' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.weekSales.total += Math.round(res.sumOrderTotal);
						$ctrl.weekSales.count += res.countOrderTotal;
						if (res.source.toUpperCase() === 'ROAD') {
							$ctrl.bookingsThisWeek += $ctrl.weekSales.total;
						}
					});

				}
			}
		});
		$ctrl.lastweekSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=LastWeek' + dateWeekStart + '&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.lastweekSales.total += Math.round(res.sumOrderTotal);
						$ctrl.lastweekSales.count += res.countOrderTotal;
					});
				}
			}
		});
		$ctrl.monthSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=Month&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.monthSales.total += Math.round(res.sumOrderTotal);
						$ctrl.monthSales.count += res.countOrderTotal;
					});
				}

				$ctrl.lastmonthSalesQuery = createAutoQuery({
					url: 'QuerySalesDailyTotals.json?dateRange=LYMTD&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
					autoLoad: true,
					pageSize: 1000,
					onLoaded: function (args) {
						if (args.total > 0) {
							args.results.forEach(function (res) {
								$ctrl.lastmonthSales.total += Math.round(res.sumOrderTotal);
								//$ctrl.lastmonthSales.count += res.countOrderTotal;
							});
							var percent = Math.round(($ctrl.monthSales.total / $ctrl.lastmonthSales.total) * 100);
							if (percent < 100) {
								$ctrl.monthSales.percent = 100 - percent;
								$ctrl.monthSales.trend = 'down';
							} else if (percent > 100) {
								$ctrl.monthSales.percent = percent - 100;
								$ctrl.monthSales.trend = 'up';
							} else {
								$ctrl.monthSales.percent = 100;
								$ctrl.monthSales.trend = 'neutral';
							}
						}
					}
				});
			}
		});
		$ctrl.quarterSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=Quarter&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.quarterSales.total += Math.round(res.sumOrderTotal);
						$ctrl.quarterSales.count += res.countOrderTotal;
					});
					var getDataUrl = 'QuerySalesDailyTotals.json?dateRange=LYQTD&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter;

					$ctrl.lastquarterSalesQuery = createAutoQuery({
						//url: 'QuerySalesDailyTotals.json?dateRange=LYQTD&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
						url: getDataUrl,
						autoLoad: true,
						onLoaded: function (args) {
							if (args.total > 0) {
								args.results.forEach(function (res) {
									$ctrl.lastquarterSales.total += Math.round(res.sumOrderTotal);
									$ctrl.lastquarterSales.count += res.countOrderTotal;
								});
								var percent = Math.round(($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100);
								if (percent < 100) {
									$ctrl.quarterSales.percent = 100 - percent;
									$ctrl.quarterSales.trend = 'down';
								} else if (percent > 100) {
									$ctrl.quarterSales.percent = percent - 100;
									$ctrl.quarterSales.trend = 'up';
								} else {
									$ctrl.quarterSales.percent = 100;
									$ctrl.quarterSales.trend = 'neutral';
								}
							}
						}
					});
				}
			}
		});
		$ctrl.ytdSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyTotals.json?dateRange=YTD&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.ytdSales.total += Math.round(res.sumOrderTotal);
						$ctrl.ytdSales.count += res.countOrderTotal;
					});
					$ctrl.lastytdSalesQuery = createAutoQuery({
						url: 'QuerySalesDailyTotals.json?dateRange=LYTD&Sum=OrderTotal&Count=OrderTotal&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
						autoLoad: true,
						onLoaded: function (args) {
							if (args.total > 0) {
								args.results.forEach(function (res) {
									$ctrl.lastytdSales.total += Math.round(res.sumOrderTotal);
									$ctrl.lastytdSales.count += res.countOrderTotal;
								});
								var percent = Math.round(($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100);
								if (percent < 100) {
									$ctrl.ytdSales.percent = 100 - percent;
									$ctrl.ytdSales.trend = 'down';
								} else if (percent > 100) {
									$ctrl.ytdSales.percent = percent - 100;
									$ctrl.ytdSales.trend = 'up';
								} else {
									$ctrl.ytdSales.percent = 100;
									$ctrl.ytdSales.trend = 'neutral';
								}
							}
						}
					});
				}
			}
		});


		this.uniqueCustomersBooked = 0;
		this.uniqueCustomersBookedQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?dateRange=Week&CountDistinct=CustomerId&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: args => {
				if (args.total > 0) {
					args.results.forEach(function (total) {
						$ctrl.uniqueCustomersBooked += total.countDistinctCustomerId;
					});
				}
			}
		});

		var startWeek = moment().startOf('week').format("MM/DD/YYYY");
		$ctrl.newAccountsBooked = 0;
		this.newAccountsBookedWTDQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?dateRange=Week&Source=ROAD&SinceCreatedDate=' + startWeek + '&CountDistinct=CustomerId&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: args => {
				if (args.total > 0) {
					args.results.forEach(function (total) {
						$ctrl.newAccountsBooked += total.countDistinctCustomerId;
					});
				}
			}
		});

		$ctrl.dailyInvoiceQuery = createAutoQuery({
			url: 'QueryInvoiceYOYTotals.json?Sum=TotalInvoiceToday,TotalInvoiceCountToday,TotalInvoiceYesterday,TotalInvoiceCountYesterday,TotalInvoiceWeekToDate,TotalInvoiceCountWeekToDate,TotalInvoiceQuarterToDate,TotalInvoiceCountQuarterToDate,TotalInvoiceQuarterToDateLastYear,TotalInvoiceCountQuarterToDateLastYear,TotalInvoiceYearToDate,TotalInvoiceCountYearToDate,TotalInvoiceYearToDateLastYear,TotalInvoiceCountYearToDateLastYear,TotalInvoiceMonthToDate,TotalInvoiceCountMonthToDate,TotalInvoiceMonthToDateLastYear,TotalInvoiceCountMonthToDateLastYear&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					var res = args.first;
					args.results.forEach(function (res) {
						$ctrl.dailyInvoice.total += res.sumTotalInvoiceToday;
						$ctrl.dailyInvoice.count += res.sumTotalInvoiceCountToday;
						$ctrl.yesterdayInvoice.total += res.sumTotalInvoiceYesterday;
						$ctrl.yesterdayInvoice.count += res.sumTotalInvoiceCountYesterday;
						$ctrl.weekInvoice.total += res.sumTotalInvoiceWeekToDate;
						$ctrl.weekInvoice.count += res.sumTotalInvoiceCountWeekToDate;
						$ctrl.quarterInvoice.total += res.sumTotalInvoiceQuarterToDate;
						$ctrl.quarterInvoice.count += res.sumTotalInvoiceCountQuarterToDate;
						$ctrl.lastquarterInvoice.total += res.sumTotalInvoiceQuarterToDateLastYear;
						$ctrl.lastquarterInvoice.count += res.sumTotalInvoiceCountQuarterToDateLastYear;
						$ctrl.ytdInvoice.total += res.sumTotalInvoiceYearToDate;
						$ctrl.ytdInvoice.count += res.sumTotalInvoiceCountYearToDate;
						$ctrl.lastytdInvoice.total += res.sumTotalInvoiceYearToDateLastYear;
						$ctrl.lastytdInvoice.count += res.sumTotalInvoiceCountYearToDateLastYear;
						$ctrl.mtdInvoice.total += res.sumTotalInvoiceMonthToDate;
						$ctrl.mtdInvoice.count += res.sumTotalInvoiceCountMonthToDate;
						$ctrl.lastmtdInvoice.total += res.sumTotalInvoiceMonthToDateLastYear;
						$ctrl.lastmtdInvoice.count += res.sumTotalInvoiceCountMonthToDateLastYear;
					});
					var percent = Math.round(($ctrl.quarterInvoice.total / $ctrl.lastquarterInvoice.total) * 100);
					if ($ctrl.lastquarterInvoice.total === 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.quarterInvoice.percent = 100 - percent;
						$ctrl.quarterInvoice.trend = 'down';
					} else if (percent > 100) {
						$ctrl.quarterInvoice.percent = percent - 100;
						$ctrl.quarterInvoice.trend = 'up';
					} else {
						$ctrl.quarterInvoice.percent = 100;
						$ctrl.quarterInvoice.trend = 'neutral';
					}
					percent = Math.round(($ctrl.ytdInvoice.total / $ctrl.lastytdInvoice.total) * 100);
					if ($ctrl.lastytdInvoice.total === 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.ytdInvoice.percent = 100 - percent;
						$ctrl.ytdInvoice.trend = 'down';
					} else if (percent > 100) {
						$ctrl.ytdInvoice.percent = percent - 100;
						$ctrl.ytdInvoice.trend = 'up';
					} else {
						$ctrl.ytdInvoice.percent = 100;
						$ctrl.ytdInvoice.trend = 'neutral';
					}
					percent = Math.round(($ctrl.mtdInvoice.total / $ctrl.lastmtdInvoice.total) * 100);
					if ($ctrl.lastmtdInvoice.total === 0) { percent = 100; }
					if (percent < 100) {
						$ctrl.mtdInvoice.percent = 100 - percent;
						$ctrl.mtdInvoice.trend = 'down';
					} else if (percent > 100) {
						$ctrl.mtdInvoice.percent = percent - 100;
						$ctrl.mtdInvoice.trend = 'up';
					} else {
						$ctrl.mtdInvoice.percent = 100;
						$ctrl.mtdInvoice.trend = 'neutral';
					}
				}
			}
		});


		//var startMonth = moment().startOf('month').format("MM/DD/YYYY");
		//this.newAccountsBookedMTDQuery = createAutoQuery({
		//  url: 'QuerySalesDailyCustomerTotals.json?dateRange=Month&SinceCreatedDate=' + startMonth + '&CountDistinct=CustomerId&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
		//  autoLoad: true,
		//  pageSize: 1000,
		//  onLoaded: args => {
		//    if (args.total > 0) {
		//      args.results.forEach(function (total) {
		//        $ctrl.newAccountsBooked += total.countDistinctCustomerId;
		//      });
		//    }
		//  }
		//});

		var startYear = moment().startOf('year').format("MM/DD/YYYY");
		this.newAccountsBookedYTDQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerTotals.json?dateRange=Year&SinceCreatedDate=' + startYear + '&CountDistinct=CustomerId&GroupBy=RepGroupName' + $ctrl.repGroupFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: args => {
				if (args.total > 0) {
					args.results.forEach(function (total) {
						$ctrl.newAccountsBookedYTD += total.countDistinctCustomerId;
					});
				}
			}
		});

		var timezone = moment.tz.guess();
		this.currentDate = moment.tz(timezone).format("DD/MM/YYYY");
		var dashboardActivityType = salesrepConfig.dashboardActivityType || "Store Appointment";
		if ($ctrl.insideSales === 'true') {
			dashboardActivityType = "Phone/Email&InsideSales=true";
		}
		dashboardActivityType = dashboardActivityType.replace(" ", "%20");

		this.storeVisitsQuery = createAutoQuery({
			url: 'QueryActivitiesJoin.json?typeIn=' + dashboardActivityType + '&dateRange=Week&Count=Id&GroupBy=username',
			autoLoad: true,
			pageSize: 1000,
			criteria: {
				currentDate: this.currentDate
			},
			onLoaded: args => {
				if (args.total > 0) {
					//$ctrl.storeVisits = Math.round(args.first.Total);
					args.results.forEach(function (total) {
						$ctrl.storeVisits += total.Total;
					});
				}
			}
		});

		$ctrl.pendingTotal = 0;
		$ctrl.pendingCount = 0;
		$ctrl.pendingOrdersQuery = createAutoQuery({
			url:
			  "QueryCartItemsJoin.json?Sum=ExtendedTotal&CountDistinct=CartId&ClientVersionNotEqualTo=%20&Exported=1&Status=Open&GroupBy=SalesRepId",
			pageSize: 1000,
			autoLoad: true,
			onLoaded: function(totals) {
			  $ctrl.chartLabels = [];
			  $ctrl.chartData = [];
			  totals.results.forEach(function(total) {
				$ctrl.pendingTotal += total.sumExtendedTotal || 0;
				$ctrl.pendingCount += total.countDistinctCartId || 0;
			  });
			}
		  });
	  
		
		$ctrl.goalsQuery = createAutoQuery({
			url: 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter,RepInsideSalesGoalThisMonth,RepInsideSalesGoalThisYear,RepInsideSalesGoalLastYear,RepInsideSalesGoalLastMonth,RepInsideSalesGoalThisQuarter&GroupBy=vendorID' + $ctrl.repGroupFilter + $ctrl.goalsFilter,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				//console.debug("$ctrl.repGroup", $ctrl.repGroup);
				if ($ctrl.repGroup == 'INSIDE SALES') {
					console.debug("args", args);
				}
				if (args.total > 0) {
					args.results.forEach(function (res) {
						
						if ($ctrl.insideSales) {
							$ctrl.goals.month += Math.round(res.sumRepInsideSalesGoalThisMonth);
							$ctrl.goals.quarter += Math.round(res.sumRepInsideSalesGoalThisQuarter);
							$ctrl.goals.year += Math.round(res.sumRepInsideSalesGoalThisYear);
						}
						else {
							if ($ctrl.repGroup == 'Inside Sales') {
								console.debug("res", res);
							}
							$ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
							$ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
							$ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
						}
					});

					$ctrl.goals.monthPercent = Math.round(
						($ctrl.monthSales.total / $ctrl.goals.month) * 100
					);
					$ctrl.goals.quarterPercent = Math.round(
						($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
					);
					$ctrl.goals.yearPercent = Math.round(
						($ctrl.ytdSales.total / $ctrl.goals.year) * 100
					);
				}
			}
		});
		this.$session = $session;
	}
	load() { return this.query.load.apply(this.query, arguments); }
}

let RepGroupDashboard = {
	bindings: {
		repGroup: '@',
		repGroupId: '@',
		header: '@',
		insideSales: '@'
	},
	controller: RepGroupDashboardController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default RepGroupDashboard;